<script>
import Layout from "../../layouts/main";
import Heading from "../../layouts/heading";
import AsidePage from "@/views/layouts/AsidePage";
import appConfig from "@/app.config";
import { emis } from "./data"


export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout, Heading, AsidePage
  },
  data() {
    return {
      page: {
      title: 'Training',
      lastUpdated: '31 Dec 2020 15:00',
      addNewBtn: false,
      deleteBtn: false,
      activeBtn: false,
      submitBtn: false,
      editPageBtn: true
    },
      pageData: emis
    };
  }
};
</script>

<template>
  <Layout>
    <Heading :page="page"></Heading>
    <div class="pl-page-container">
      <!-- <aside-page v-if="pageData.data.layout === 'aside'">
        <template v-slot:main>
          <template v-for="(component, index) in pageData.data.mainBlocks">
            <component
              :key="`main-${index}`"
              :is="component.component"
              v-bind="pageData.data[component.props]"
            ></component>
          </template>
        </template>
        <template v-slot:aside>
          <template v-for="(component, index) in pageData.data.asideBlocks">
            <component
              :key="`aside-${index}`"
              :is="component.component"
              v-bind="pageData.data[component.props]"
            ></component>
          </template>
        </template>
      </aside-page> -->
      <aside-page>
        <template v-slot:main>
          <PageTitle :img="pageData.pageTitle.img" :title="pageData.pageTitle.title" :text="pageData.pageTitle.text"/>
          <PageTabsBlock
            :featuresNav="pageData.pageTabs.featuresNav"
            :tabItems="pageData.pageTabs.tabItems"
            ref="features"
          >
          <template v-slot:document>
          </template>
          <template v-slot:video>
            <VideoCarousel :video="pageData.video"/> 
          </template>
          <template v-slot:query>
            <QueryForm :formProps="pageData.queryForm.formProps"/> 
          </template>
        </PageTabsBlock>
        </template> 
        <template v-slot:aside>
          <AsideInfoBlock :blockTitle="pageData.faqs.blockTitle" :cards="pageData.faqs.cards"/>
        </template>
      </aside-page>
    </div>
  </Layout>
</template>
